var _path, _ellipse, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.9,
    y: 10.8,
    style: {
      fill: "#000"
    },
    width: 1,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.1,
    y: 10.7,
    style: {
      fill: "#000"
    },
    width: 1,
    height: 0.5
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,11.8v2.5c0,0.3-0.3,0.6-0.6,0.6H5.2l-0.9-0.1l-1.5-0.1c-0.2,0-0.4-0.2-0.4-0.4V8.3C2.3,7.6,2.8,7,3.6,7 h11.7c0.4,0,0.7,0.2,0.8,0.5l1.4,2.6l4.4,0.4C22.5,10.6,23,11.1,23,11.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M3.4,8.4v1.9h3.3V7.7H4.1C3.8,7.7,3.4,8,3.4,8.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "7.8,7.7 7.8,10.4 11.5,10.4 11.5,7.7  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M16.7,10.4l-1.1-2.2c-0.1-0.2-0.4-0.4-0.6-0.4h-2.4v2.6L16.7,10.4L16.7,10.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#000"
    },
    cx: 6.7,
    cy: 15,
    rx: 2,
    ry: 2
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.7,
    cy: 15,
    rx: 1.2,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 6.7,
    cy: 15,
    r: 0.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#000"
    },
    cx: 17.1,
    cy: 15,
    rx: 2,
    ry: 2
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.1,
    cy: 15,
    r: 1.2
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 17.1,
    cy: 15,
    r: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M2.3,8.6L2.3,8.6C1.6,8.6,1,9.2,1,9.9v1.3c0,0.7,0.6,1.3,1.3,1.3l0,0V8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M21.8,10.5l-0.6,0v1.4c0,0.4,0.3,0.6,0.6,0.6H23v-0.7C23,11.1,22.5,10.6,21.8,10.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.8,
    y: 10.8,
    style: {
      fill: "#000"
    },
    width: 1.2,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.1,
    y: 10.8,
    style: {
      fill: "#000"
    },
    width: 1.2,
    height: 0.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuv);
export default __webpack_public_path__ + "static/media/suv.344284882d3f2fbe0dd64012a87b6dc1.svg";
export { ForwardRef as ReactComponent };